// frontend/src/components/OfflineBanner.jsx
// Persistent, unmissable banner shown across the whole authenticated shell
// whenever the device has no connection — see hooks/useOnlineStatus.js.
// Rendered once in AppLayout so every page gets it without per-page wiring.
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div className="flex-shrink-0 bg-red/15 border-b border-red/30 text-red px-4 py-2 flex items-center justify-center gap-2 text-xs font-semibold">
      <WifiOff className="w-3.5 h-3.5 flex-shrink-0" />
      You're offline — please reconnect to access your wallet
    </div>
  );
}
